import BaseModel from '../base/BaseModel.model';
export default class Association extends BaseModel {
    public userId?: number;
    public organizationName?: string;
    public typeOfMembership?:  string;

    constructor(){
        super();
        this.init();
    }

    init(){ 
        this.userId = undefined;
        this.organizationName = "";
        this.typeOfMembership = "";   
    }
}